import { useState, useEffect, useMemo } from 'react';
import _, { isEqual } from 'lodash';
import { Formik, Form } from 'formik';
import Yup from '../../utils/yup';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import companyService from '../../service/company.service';
import documentTypeService from '../../service/newDocumentType.service';
import { NotificationType } from '../../config';
import addNotification from '../../utils/addNotification';
import useMenus from '../../context/MenuContext';
import useParam from '../../context/ParamContext';
import useUsers from '../../context/UsersContext';
import { getDynVals } from '../../utils/DynHelper';

import FormTabs from './FormTabs';
import CompanyReports from './CompanyReports';
import FormFields from './FormFields';
import { FormHeaderUI, FormButtonPanelUI, DeleteDialogUI, FormBase, ButtonUI } from '../Interface';
import CompanySettingsMenu from './CompanySettingsMenu';
import CompanyDocReportsDialog from './CompanyDocReportsDialog';
import CompanyEmailDialog from './CompanyEmailDialog';
import masterDataService from '../../service/masterData.service';
import { cleanValues, generateAutocompleteItems, getJokerFieldType } from '../../utils/helper';
import { BpType } from '../../config/company';
import { GroupType } from '../../config/companyGroup';
import { CategoryOptionType } from '../../config/vatCodes';
import { useNavigate, useParams } from 'react-router-dom';
import useConfig from '../../context/ConfigContext';
import usePages from '../../context/PageContext';
import { JokerFieldTypes, JokerTypes } from '../../config/joker';
import jokerService from '../../service/joker.service';
import CompanySalesPersonDialog from './CompanySalesPersonDialog';

export const CompanyPage = ({ fromDialog, dialogSetSelectedCompany, selectedCompanyId, hideRightPanel = false }) => {
  const navigate = useNavigate();
  const { setPages } = usePages();
  const { id } = useParams();
  const resolvedCompanyId = selectedCompanyId ?? id;
  const { user, getUser } = useUsers();
  const { config, getConfig } = useConfig();
  const { menus, getMenus, getMenuSubMenuId, getCanEdit, getSubMenuNamesByUrls, getCanCopy, getCanDelete } = useMenus();
  const { getParam, params } = useParam();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [viewField, setViewField] = useState(true);
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [addField, setAddField] = useState(true);
  const [dynProps, setDynProps] = useState([]);

  const [submenu, setSubmenu] = useState(null);
  const [refetchTable, setRefetchTable] = useState(false);
  const [operatorsDisabled, setOperatorsDisabled] = useState(false);
  const [selectedValues, setSelectedValues] = useState({});
  const [initValues, setInitValues] = useState({});
  const [defaultValues, setDefaultValues] = useState({});
  const [canEdit, setCanEdit] = useState(true);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});
  const [autocompleteData, setAutocompleteData] = useState({});
  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    status: [],
    companyGroup: [],
    language: [],
    priceList: [],
    paymentMethod: [],
    currency: [],
    vatCode: [],
    incoterm: [],
    salesOrPurchasePerson: [],
    deliveryMethod: [],
    country: [],
    costCenter: [],
  });
  const [loading, setLoading] = useState(true);
  const [dynLoading, setDynLoading] = useState(true);
  const isLoading = loading || dynLoading;
  const [canCopy, setCanCopy] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [jokerFields, setJokerFields] = useState([]);
  const [jokerLoading, setJokerLoading] = useState(true);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [docReportsDialogOpen, setDocReportsDialogOpen] = useState(false);
  const [companyEmailDialogOpen, setCompanyEmailDialogOpen] = useState(false);
  const [salesPersonDialogOpen, setSalesPersonDialogOpen] = useState(false);

  const getJokerFields = () => {
    jokerService
      .getFields(JokerTypes.COMPANY)
      .then((data) => {
        setJokerFields(data);
      })
      .finally(() => {
        setJokerLoading(false);
      });
  };

  const submenuNames = useMemo(() => {
    return getSubMenuNamesByUrls(['contactMap']);
  }, [menus]);

  const defaultContact = {
    id: null,
    isNew: true,
    name: '',
    role: '',
    phoneNumber: '',
    email: '',
    phoneNumber2: '',
    comment: '',
    active: true,
    other: '',
    default: false,
    createdBy: user.userId,
    salutation: '',
    newsletter: false,
  };

  const defaultAddress = {
    id: null,
    isNew: true,
    name: '',
    adressType: '',
    countryCode: '',
    province: '',
    postCode: '',
    city: '',
    streetAddress: '',
    GLN: '',
    active: true,
    other: '',
    default: false,
    createdBy: user.userId,
  };

  const defaultBank = {
    id: null,
    isNew: true,
    bankAccountNumber: '',
    iban: '',
    costCenterCode: '',
    currencyCode: '',
    description: '',
  };

  const def = {
    code: '',
    name: '',
    shortName: '',
    supplier: false,
    cooperation: false,
    customer: false,
    lead: false,
    supplierGroupId: null,
    customerGroupId: null,
    bpType: BpType.COMPANY,
    languageCode: '',
    active: true,
    website: '',
    email: '',
    phoneNumber: '',
    GLN: '',
    hunTaxNumber: '',
    euTaxNumber: '',
    foreignTaxNumber: '',
    description: '',
    statusId: null,
    supplierPriceListId: null,
    supplierPaymentMethodId: null,
    supplierCurrencyCode: '',
    supplierVatCode: '',
    supplierDeliveryMethodId: null,
    supplierIncotermCode: '',
    purchasePersonId: null,
    customerPriceListId: null,
    customerPaymentMethodId: null,
    customerCurrencyCode: '',
    customerVatCode: '',
    customerDeliveryMethodId: null,
    customerIncotermCode: '',
    salesPersonId: null,
    class1: false,
    class2: false,
    class3: false,
    class4: false,
    class5: false,
    class6: false,
    class7: false,
    class8: false,
    class9: false,
    class10: false,
    class11: false,
    class12: false,
    class13: false,
    class14: false,
    class15: false,
    class16: false,
    class17: false,
    class18: false,
    class19: false,
    class20: false,
    incotermCity: '',
    companyWarning: '',
    contact: [],
    address: [],
    companyBank: [],
    companyDocReports: [],
    companyEmail: [],
    registrationNumber: '',
    joker_char1: '',
    joker_char2: '',
    joker_char3: '',
    joker_char4: '',
    joker_char5: '',
    joker_char6: '',
    joker_char7: '',
    joker_char8: '',
    joker_char9: '',
    joker_char10: '',
    joker_date1: null,
    joker_date2: null,
    joker_date3: null,
    joker_date4: null,
    joker_date5: null,
    joker_num1: '',
    joker_num2: '',
    joker_num3: '',
    joker_num4: '',
    joker_num5: '',
    joker_int1: '',
    joker_int2: '',
    joker_int3: '',
    joker_int4: '',
    joker_int5: '',
  };

  useEffect(() => {
    getMenus();
    getParam();
    if (!Object.keys(user).length) getUser();
    if (!Object.keys(config).length) getConfig();
    documentTypeService.allDocumentTypes().then((data) => {
      setDocumentTypes(Array.isArray(data) ? data : []);
    });

    setDefaultValues(def);
    getJokerFields();
  }, []);

  useEffect(() => {
    if (fromDialog && Object.keys(selectedValues).length > 0) {
      dialogSetSelectedCompany(selectedValues ?? null);
    }
  }, [selectedValues]);

  useEffect(() => {
    if (Object.keys(autocompleteData).length > 0) {
      setDefaultValues((prev) => {
        return {
          ...prev,
          statusId: autocompleteData?.status?.defaultValue ?? null,
        };
      });

      setDefaultSelectedValues((prev) => {
        return {
          ...prev,
          status: autocompleteData?.status?.defItem,
        };
      });
    }
  }, [autocompleteData]);

  useEffect(() => {
    if (submenu) {
      initDefaultValues();
    }
  }, [submenu]);

  useEffect(() => {
    setSelectedValues(defaultSelectedValues);
  }, [defaultSelectedValues]);

  useEffect(() => {
    const submenuId = getMenuSubMenuId('company');
    setSubmenu(submenuId);
    setCanEdit(getCanEdit(submenuId));
    setCanCopy(getCanCopy(submenuId));
    setCanDelete(getCanDelete(submenuId));
  }, [menus]);

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!_.isEqual(defaultSelectedValues, selectedValues)) {
        valuesToForm();
        setOperatorsDisabled(false);
      } else {
        setOperatorsDisabled(true);
        setInitValues(defaultValues);
      }
    }
  }, [selectedValues]);

  useEffect(() => {
    if (resolvedCompanyId && !loading) {
      companyService.getCompanyById(resolvedCompanyId).then((data) => {
        setSelectedValues(data);
        setRowSelectionModel(data.id);
      });
    } else {
      setSelectedValues(defaultSelectedValues);
    }
  }, [defaultSelectedValues, resolvedCompanyId, loading]);

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .statusToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyGroupToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .languageToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .priceListToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .paymentMethodToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .currencyToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .vatCodeToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .incotermToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .salesOrPurchasePersonToForm()
          .then((data) => {
            resolve(data.filter((d) => !d.deletedBy));
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .deliveryMethodToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .countryToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .costCenterToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          status: resp[0],
          companyGroup: resp[1],
          language: resp[2],
          priceList: resp[3],
          paymentMethod: resp[4],
          currency: resp[5],
          vatCode: resp[6],
          incoterm: resp[7],
          salesOrPurchasePerson: resp[8],
          deliveryMethod: resp[9],
          country: resp[10],
          costCenter: resp[11],
        };
        setAutocompleteData(aData);

        const acOptions = {
          status: generateAutocompleteItems(aData.status.statusItems, 'itemName', 'itemId'),
          companyGroup: generateAutocompleteItems(aData.companyGroup, 'name', 'id'),
          language: generateAutocompleteItems(aData.language, 'name', 'code'),
          priceList: generateAutocompleteItems(aData.priceList, 'name', 'id'),
          paymentMethod: generateAutocompleteItems(aData.paymentMethod, 'name', 'id'),
          currency: generateAutocompleteItems(aData.currency, 'code', 'code'),
          vatCode: generateAutocompleteItems(aData.vatCode, 'code', 'code'),
          incoterm: generateAutocompleteItems(aData.incoterm, 'name', 'code'),
          salesOrPurchasePerson: generateAutocompleteItems(aData.salesOrPurchasePerson, 'name', 'id'),
          deliveryMethod: generateAutocompleteItems(aData.deliveryMethod, 'name', 'id'),
          country: generateAutocompleteItems(aData.country, 'name', 'code'),
          costCenter: generateAutocompleteItems(aData.costCenter, 'code', 'code'),
        };
        setAutoCompleteOptions(acOptions);
        setLoading(false);
      })
      .finally(() => {
        //hideLoader();
      });
  };
  const validationSchema = Yup.object().shape({
    code: Yup.string().nullable(),
    name: Yup.string().required(),
    shortName: Yup.string().nullable(),
    supplier: Yup.boolean(),
    cooperation: Yup.boolean(),
    customer: Yup.boolean(),
    lead: Yup.boolean(),
    supplierGroupId: Yup.string().nullable(),
    customerGroupId: Yup.string().nullable(),
    bpType: Yup.string().nullable(),
    languageCode: Yup.string().nullable(),
    active: Yup.boolean(),
    website: Yup.string().nullable(),
    email: Yup.string().nullable(),
    phoneNumber: Yup.string().nullable(),
    GLN: Yup.string().nullable(),
    hunTaxNumber: Yup.string()
      .nullable()
      .matches(/^\d{8}-\d{1,2}-\d{2}$/, {
        message: 'A magyar adószám formátuma helytelen. Helyes formátum például: 12345678-1-23',
        excludeEmptyString: true,
      }),
    euTaxNumber: Yup.string()
      .nullable()
      .matches(/^[A-Z]{2}[A-Z0-9]{2,18}$/, {
        message: 'Az EU adószám formátuma helytelen. Helyes formátum például: HU12345678',
        excludeEmptyString: true,
      }),
    foreignTaxNumber: Yup.string().nullable(),
    description: Yup.string().nullable(),
    statusId: Yup.string().nullable(),
    supplierPriceListId: Yup.string().nullable(),
    supplierPaymentMethodId: Yup.string().nullable(),
    supplierCurrencyCode: Yup.string().nullable(),
    supplierVatCode: Yup.string().nullable(),
    supplierDeliveryMethodId: Yup.string().nullable(),
    supplierIncotermCode: Yup.string().nullable(),
    purchasePersonId: Yup.string().nullable(),
    customerPriceListId: Yup.string().nullable(),
    customerPaymentMethodId: Yup.string().nullable(),
    customerCurrencyCode: Yup.string().nullable(),
    customerVatCode: Yup.string().nullable(),
    customerDeliveryMethodId: Yup.string().nullable(),
    customerIncotermCode: Yup.string().nullable(),
    salesPersonId: Yup.string().nullable(),
    shortName: Yup.string().nullable(),
    incotermCity: Yup.string().nullable(),
    companyWarning: Yup.string().nullable(),
    registrationNumber: Yup.string().nullable(),
    class1: Yup.boolean(),
    class2: Yup.boolean(),
    class3: Yup.boolean(),
    class4: Yup.boolean(),
    class5: Yup.boolean(),
    class6: Yup.boolean(),
    class7: Yup.boolean(),
    class8: Yup.boolean(),
    class9: Yup.boolean(),
    class10: Yup.boolean(),
    class11: Yup.boolean(),
    class12: Yup.boolean(),
    class13: Yup.boolean(),
    class14: Yup.boolean(),
    class15: Yup.boolean(),
    class16: Yup.boolean(),
    class17: Yup.boolean(),
    class18: Yup.boolean(),
    class19: Yup.boolean(),
    class20: Yup.boolean(),
    contact: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required(),
        role: Yup.string().required(),
        phoneNumber: Yup.string().nullable(),
        email: Yup.string().nullable(),
        phoneNumber2: Yup.string().nullable(),
        comment: Yup.string().nullable(),
        active: Yup.boolean(),
        other: Yup.string().nullable(),
        default: Yup.boolean(),
        salutation: Yup.string().nullable(),
        newsletter: Yup.boolean(),
      })
    ),
    address: Yup.array().of(
      Yup.object().shape({
        name: Yup.string().required(),
        adressType: Yup.string().required(),
        countryCode: Yup.string().nullable(),
        province: Yup.string().nullable(),
        postCode: Yup.string().nullable(),
        city: Yup.string().nullable(),
        streetAddress: Yup.string().nullable(),
        GLN: Yup.string().nullable(),
        active: Yup.boolean(),
        other: Yup.string().nullable(),
        default: Yup.boolean(),
      })
    ),
    companyBank: Yup.array().of(
      Yup.object().shape({
        bankAccountNumber: Yup.string().required(),
        iban: Yup.string().nullable(),
        costCenterCode: Yup.string().nullable(),
        currencyCode: Yup.string().nullable(),
        description: Yup.string().nullable(),
      })
    ),
    companyEmail: Yup.array().of(
      Yup.object().shape({
        documentTypeId: Yup.number().required(),
        email: Yup.string().required(),
        comment: Yup.string().nullable(),
      })
    ),
    ...(jokerFields.length > 0
      ? Object.fromEntries(
          jokerFields.map((field) => {
            const fieldType = getJokerFieldType(field);
            return [
              field.field,
              fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
            ];
          })
        )
      : {}),
  });

  const valuesToForm = () => {
    const {
      code,
      name,
      shortName,
      supplier,
      cooperation,
      customer,
      lead,
      supplierGroupId,
      customerGroupId,
      bpType,
      languageCode,
      active,
      website,
      email,
      phoneNumber,
      GLN,
      hunTaxNumber,
      euTaxNumber,
      foreignTaxNumber,
      other,
      description,
      statusId,
      supplierPriceListId,
      supplierPaymentMethodId,
      supplierCurrencyCode,
      supplierVatCode,
      supplierDeliveryMethodId,
      supplierIncotermCode,
      purchasePersonId,
      customerPriceListId,
      customerPaymentMethodId,
      customerCurrencyCode,
      customerVatCode,
      customerDeliveryMethodId,
      customerIncotermCode,
      salesPersonId,
      companyAdress,
      companyContact,
      class1,
      class2,
      class3,
      class4,
      class5,
      class6,
      class7,
      class8,
      class9,
      class10,
      class11,
      class12,
      class13,
      class14,
      class15,
      class16,
      class17,
      class18,
      class19,
      class20,
      incotermCity,
      companyWarning,
      companyBank,
      companyDocReports,
      companyEmail,
      registrationNumber,
      joker_char1,
      joker_char2,
      joker_char3,
      joker_char4,
      joker_char5,
      joker_char6,
      joker_char7,
      joker_char8,
      joker_char9,
      joker_char10,
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1,
      joker_num2,
      joker_num3,
      joker_num4,
      joker_num5,
      joker_int1,
      joker_int2,
      joker_int3,
      joker_int4,
      joker_int5,
    } = selectedValues;

    setInitValues({
      code: code || '',
      name,
      shortName: shortName || '',
      supplier,
      cooperation,
      customer,
      lead,
      supplierGroupId,
      customerGroupId,
      bpType,
      languageCode,
      active,
      website: website || '',
      email: email || '',
      phoneNumber: phoneNumber || '',
      GLN: GLN || '',
      hunTaxNumber: hunTaxNumber || '',
      euTaxNumber: euTaxNumber || '',
      foreignTaxNumber: foreignTaxNumber || '',
      other: other || '',
      description: description || '',
      registrationNumber: registrationNumber || '',
      statusId,
      supplierPriceListId,
      supplierPaymentMethodId,
      supplierCurrencyCode,
      supplierVatCode,
      supplierDeliveryMethodId,
      supplierIncotermCode,
      purchasePersonId,
      customerPriceListId,
      customerPaymentMethodId,
      customerCurrencyCode,
      customerVatCode,
      customerDeliveryMethodId,
      customerIncotermCode,
      salesPersonId,
      class1,
      class2,
      class3,
      class4,
      class5,
      class6,
      class7,
      class8,
      class9,
      class10,
      class11,
      class12,
      class13,
      class14,
      class15,
      class16,
      class17,
      class18,
      class19,
      class20,
      joker_char1: joker_char1 ?? '',
      joker_char2: joker_char2 ?? '',
      joker_char3: joker_char3 ?? '',
      joker_char4: joker_char4 ?? '',
      joker_char5: joker_char5 ?? '',
      joker_char6: joker_char6 ?? '',
      joker_char7: joker_char7 ?? '',
      joker_char8: joker_char8 ?? '',
      joker_char9: joker_char9 ?? '',
      joker_char10: joker_char10 ?? '',
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1: joker_num1 ?? '',
      joker_num2: joker_num2 ?? '',
      joker_num3: joker_num3 ?? '',
      joker_num4: joker_num4 ?? '',
      joker_num5: joker_num5 ?? '',
      joker_int1: joker_int1 ?? '',
      joker_int2: joker_int2 ?? '',
      joker_int3: joker_int3 ?? '',
      joker_int4: joker_int4 ?? '',
      joker_int5: joker_int5 ?? '',
      incotermCity: incotermCity || '',
      companyWarning: companyWarning || '',
      dynamicFields: getDynVals(dynProps, selectedValues.dynamicProperties),
      contact:
        companyContact?.map((pc) => ({
          id: pc.id,
          name: pc.name,
          role: pc.role,
          phoneNumber: pc.phoneNumber,
          email: pc.email,
          phoneNumber2: pc.phoneNumber2,
          comment: pc.comment,
          active: pc.active,
          other: pc.other,
          default: pc.default,
          salutation: pc.salutation,
          newsletter: pc.newsletter,
        })) ?? [],

      address:
        companyAdress?.map((pc) => ({
          id: pc.id,
          name: pc.name,
          adressType: pc.adressType,
          countryCode: pc.countryCode,
          province: pc.province,
          postCode: pc.postCode,
          city: pc.city,
          streetAddress: pc.streetAddress,
          GLN: pc.GLN,
          active: pc.active,
          other: pc.other,
          default: pc.default,
        })) ?? [],

      companyBank:
        companyBank?.map((cb) => ({
          id: cb.id,
          bankAccountNumber: cb.bankAccountNumber,
          iban: cb.iban,
          costCenterCode: cb.costCenterCode,
          currencyCode: cb.currencyCode,
          description: cb.description,
        })) ?? [],
      companyDocReports:
        companyDocReports?.map((report) => ({
          id: report.id,
          companyId: report.companyId ?? selectedValues.id ?? null,
          documentTypeId: report.documentTypeId,
          reportId: report.reportId ?? null,
          createdBy: report.createdBy,
          updatedBy: report.updatedBy,
          deletedBy: report.deletedBy,
        })) ?? [],
      companyEmail:
        companyEmail?.map((emailRow) => ({
          id: emailRow.id,
          companyId: emailRow.companyId ?? selectedValues.id ?? null,
          documentTypeId: emailRow.documentTypeId ?? null,
          email: emailRow.email ?? '',
          comment: emailRow.comment ?? '',
        })) ?? [],
    });
  };

  const handleSubmit = (values) => {
    if (!editButtonVisible) {
      updateObject(values);
    } else if (!addField) {
      handleInsertObject(values);
    }
  };

  const updateObject = async (values) => {
    const updData = {
      ...cleanValues(values),
      companyEmail:
        values.companyEmail?.map((emailRow) => ({
          ...(emailRow.id ? { id: emailRow.id } : {}),
          companyId: emailRow.companyId ?? selectedValues.id ?? null,
          documentTypeId: emailRow.documentTypeId,
          email: emailRow.email,
          comment: emailRow.comment || null,
        })) ?? [],
      updatedBy: user.userId,
    };

    companyService.updateCompany(updData, selectedValues.id).then((data) => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });

      setSelectedValues(data);
      setRefetchTable(true);
      setEditButtonvisible(true);
      setViewField(true);
    });
  };

  const handleInsertObject = async (values) => {
    const insertObject = {
      ...cleanValues(values),
      companyEmail:
        values.companyEmail?.map((emailRow) => ({
          ...(emailRow.id ? { id: emailRow.id } : {}),
          companyId: emailRow.companyId ?? null,
          documentTypeId: emailRow.documentTypeId,
          email: emailRow.email,
          comment: emailRow.comment || null,
        })) ?? [],
      createdBy: user.userId,
    };

    companyService
      .createCompany(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });
        setRefetchTable(true);
        setAddField(true);
        setViewField(true);
        setSelectedValues(data);

        setRowSelectionModel(data.id);
      })
      .finally(() => {
        //@TODO loader
      });
  };

  dayjs.extend(utc);

  const handleRemoveElement = async () => {
    const deleteData = {
      deletedBy: user.userId,
    };
    companyService.deleteCompany(deleteData, selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres törlés!',
        type: NotificationType.WARNING,
      });
      setRefetchTable(true);
      setShowDeleteDialog(false);
      setSelectedValues(defaultValues);
    });
  };

  const handleTemplate = () => {
    companyService.getExcelTemplate().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleExport = () => {
    companyService.getExcelData().then(() => {
      addNotification({
        content: 'A letöltés elindult!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const handleImport = (files) => {
    companyService.importExcel(files, user.userId).then(() => {
      setRefetchTable(true);
      addNotification({
        content: 'Az import sikeres!',
        type: NotificationType.SUCCESS,
      });
    });
  };

  const customerGroups = generateAutocompleteItems(
    autocompleteData.companyGroup?.filter((group) => group.groupType === GroupType.CUSTOMERGROUP),
    'name',
    'id'
  );
  const supplierGroups = generateAutocompleteItems(
    autocompleteData.companyGroup?.filter((group) => group.groupType === GroupType.SUPPLIERGROUP),
    'name',
    'id'
  );

  const customerVatCode = generateAutocompleteItems(
    autocompleteData.vatCode?.filter((v) => v.category === CategoryOptionType.K),
    'code',
    'code'
  );
  const supplierVatCode = generateAutocompleteItems(
    autocompleteData.vatCode?.filter((v) => v.category === CategoryOptionType.B),
    'code',
    'code'
  );

  const salesPerson = generateAutocompleteItems(
    autocompleteData.salesOrPurchasePerson?.filter((s) => s.salesPerson === true),
    'name',
    'id'
  );
  const purchasePerson = generateAutocompleteItems(
    autocompleteData.salesOrPurchasePerson?.filter((p) => p.purchaser === true),
    'name',
    'id'
  );

  const validate = (formValues) => {
    const values = cleanValues(formValues);
    try {
      validationSchema.validateSync(values, { abortEarly: false });
      return {};
    } catch (err) {
      const errors = err.inner.reduce((acc, error) => {
        acc[error.path] = error.message;
        return acc;
      }, {});

      const hasAddressError = err.inner.some((e) => e.path.startsWith('address'));
      const hasContactError = err.inner.some((e) => e.path.startsWith('contact'));

      const onlyAddressAndContactErrors = err.inner.every(
        (e) => e.path.startsWith('address') || e.path.startsWith('contact')
      );

      if (onlyAddressAndContactErrors) {
        if (hasAddressError) {
          addNotification({
            content: 'Kitöltetlen kötelező mezők az üzleti partner címekben!',
            type: NotificationType.ERROR,
          });
        }

        if (hasContactError) {
          addNotification({
            content: 'Kitöltetlen kötelező mezők az üzleti partner kapcsolattartókban!',
            type: NotificationType.ERROR,
          });
        }
      }

      return errors;
    }
  };

  const handleNavigate = () => {
    setPages({ subMenuName: submenuNames });
    navigate(`/app/contactMap/${selectedValues.id}`);
  };

  const mainContent = (
    <>
      <div className="h-full overflow-auto custom-scrollbar">
        <div className="flex items-center flex-wrap gap-2">
          <FormHeaderUI
            addClick={() => {
              setSelectedValues(defaultSelectedValues);
              setViewField(false);
              setAddField(false);
            }}
            addDisabled={!viewField || !canEdit}
            modClick={() => {
              setViewField(false);
              setEditButtonvisible(false);
            }}
            modDisabled={!viewField || operatorsDisabled || !canEdit}
            deleteClick={() => {
              setShowDeleteDialog(true);
            }}
            deleteDisabled={!viewField || operatorsDisabled || !canEdit || !canDelete}
            copyClick={() => {
              setViewField(false);
              setAddField(false);
            }}
            copyDisabled={!viewField || operatorsDisabled || !canEdit || !canCopy}
          />
          <ButtonUI
            text="Kapcsolattérkép"
            size="sm"
            className="bg-labelColor py-3"
            onClick={handleNavigate}
            disabled={!viewField || operatorsDisabled}
          />
          <CompanySettingsMenu
            disabled={operatorsDisabled && viewField}
            onOpenDocReports={() => setDocReportsDialogOpen(true)}
            onOpenEmails={() => setCompanyEmailDialogOpen(true)}
          />
        </div>

        <Formik
          validate={validate}
          initialValues={initValues}
          validationSchema={validationSchema}
          validateOnChange={false}
          onSubmit={handleSubmit}
          enableReinitialize
          validateOnBlur={false}
          validateOnMount={false}
        >
          {({ values, errors, resetForm, setFieldValue, validateField }) => (
            <Form>
              <FormFields
                viewField={viewField}
                selectedValues={selectedValues}
                autocompleteOptions={autocompleteOptions}
                customerGroups={customerGroups}
                supplierGroups={supplierGroups}
                autocompleteData={autocompleteData}
              />

              {!jokerLoading && (
                <FormTabs
                  values={values}
                  errors={errors}
                  disabled={viewField}
                  setFieldValue={setFieldValue}
                  selectedValues={selectedValues}
                  validateField={validateField}
                  submenuId={submenu}
                  params={params}
                  user={user}
                  setRefetchTable={setRefetchTable}
                  setDefaultValues={setDefaultValues}
                  dynProperties={{ dynProps, setDynProps }}
                  defaultContact={defaultContact}
                  defaultAddress={defaultAddress}
                  dynLoadingState={{ dynLoading, setDynLoading }}
                  setSelectedValues={setSelectedValues}
                  handleImport={handleImport}
                  handleExport={handleExport}
                  handleTemplate={handleTemplate}
                  autocompleteOptions={autocompleteOptions}
                  customerVatCode={customerVatCode}
                  supplierVatCode={supplierVatCode}
                  salesPerson={salesPerson}
                  purchasePerson={purchasePerson}
                  defaultBank={defaultBank}
                  jokerFields={jokerFields}
                  documentTypes={documentTypes}
                  setSalesPersonDialogOpen={setSalesPersonDialogOpen}
                  addField={addField}
                />
              )}

              <CompanyDocReportsDialog
                open={docReportsDialogOpen}
                onClose={() => setDocReportsDialogOpen(false)}
                disabled={viewField}
                documentTypes={documentTypes}
                selectedValues={selectedValues}
                valuesState={{ values, setFieldValue }}
              />

              <CompanyEmailDialog
                open={companyEmailDialogOpen}
                onClose={() => setCompanyEmailDialogOpen(false)}
                disabled={viewField}
                documentTypes={documentTypes}
                selectedValues={selectedValues}
                valuesState={{ values, errors, setFieldValue }}
              />

              <FormButtonPanelUI
                onCancelClick={() => {
                  setViewField(true);
                  setEditButtonvisible(true);
                  setAddField(true);
                  resetForm();
                }}
                disabled={editButtonVisible && addField}
              />
            </Form>
          )}
        </Formik>
      </div>
    </>
  );

  return (
    <>
      {hideRightPanel ? (
        mainContent
      ) : (
        <FormBase
          name="Company"
          leftPanelContent={
            <>
              <div className="h-full overflow-auto custom-scrollbar">
                <div className="flex items-center flex-wrap gap-2">
                  <FormHeaderUI
                    addClick={() => {
                      setSelectedValues(defaultSelectedValues);
                      setViewField(false);
                      setAddField(false);
                    }}
                    addDisabled={!viewField || !canEdit}
                    modClick={() => {
                      setViewField(false);
                      setEditButtonvisible(false);
                    }}
                    modDisabled={!viewField || operatorsDisabled || !canEdit}
                    deleteClick={() => {
                      setShowDeleteDialog(true);
                    }}
                    deleteDisabled={!viewField || operatorsDisabled || !canEdit || !canDelete}
                    copyClick={() => {
                      setViewField(false);
                      setAddField(false);
                    }}
                    copyDisabled={!viewField || operatorsDisabled || !canEdit || !canCopy}
                  />
                  <ButtonUI
                    text="Kapcsolattérkép"
                    size="sm"
                    className="bg-labelColor py-3"
                    onClick={handleNavigate}
                    disabled={!viewField || operatorsDisabled}
                  />
                  <CompanySettingsMenu
                    disabled={operatorsDisabled && viewField}
                    onOpenDocReports={() => setDocReportsDialogOpen(true)}
                    onOpenEmails={() => setCompanyEmailDialogOpen(true)}
                  />
                </div>

                <Formik
                  validate={validate}
                  initialValues={initValues}
                  validationSchema={validationSchema}
                  validateOnChange={false}
                  onSubmit={handleSubmit}
                  enableReinitialize
                  validateOnBlur={false}
                  validateOnMount={false}
                >
                  {({ values, errors, resetForm, setFieldValue, validateField }) => (
                    <Form>
                      <FormFields
                        viewField={viewField}
                        selectedValues={selectedValues}
                        autocompleteOptions={autocompleteOptions}
                        customerGroups={customerGroups}
                        supplierGroups={supplierGroups}
                        autocompleteData={autocompleteData}
                      />

                      {!jokerLoading && (
                        <FormTabs
                          values={values}
                          errors={errors}
                          disabled={viewField}
                          setFieldValue={setFieldValue}
                          selectedValues={selectedValues}
                          validateField={validateField}
                          submenuId={submenu}
                          params={params}
                          user={user}
                          setRefetchTable={setRefetchTable}
                          setDefaultValues={setDefaultValues}
                          dynProperties={{ dynProps, setDynProps }}
                          defaultContact={defaultContact}
                          defaultAddress={defaultAddress}
                          dynLoadingState={{ dynLoading, setDynLoading }}
                          setSelectedValues={setSelectedValues}
                          handleImport={handleImport}
                          handleExport={handleExport}
                          handleTemplate={handleTemplate}
                          autocompleteOptions={autocompleteOptions}
                          customerVatCode={customerVatCode}
                          supplierVatCode={supplierVatCode}
                          salesPerson={salesPerson}
                          purchasePerson={purchasePerson}
                          defaultBank={defaultBank}
                          jokerFields={jokerFields}
                          documentTypes={documentTypes}
                          setSalesPersonDialogOpen={setSalesPersonDialogOpen}
                          addField={addField}
                        />
                      )}

                      <CompanyDocReportsDialog
                        open={docReportsDialogOpen}
                        onClose={() => setDocReportsDialogOpen(false)}
                        disabled={viewField}
                        documentTypes={documentTypes}
                        selectedValues={selectedValues}
                        valuesState={{ values, setFieldValue }}
                      />

                      <CompanyEmailDialog
                        open={companyEmailDialogOpen}
                        onClose={() => setCompanyEmailDialogOpen(false)}
                        disabled={viewField}
                        documentTypes={documentTypes}
                        selectedValues={selectedValues}
                        valuesState={{ values, errors, setFieldValue }}
                      />

                      <FormButtonPanelUI
                        onCancelClick={() => {
                          setViewField(true);
                          setEditButtonvisible(true);
                          setAddField(true);
                          resetForm();
                        }}
                        disabled={editButtonVisible && addField}
                      />
                    </Form>
                  )}
                </Formik>
              </div>
            </>
          }
          rightPanelContent={
            <>
              {!isLoading && (
                <CompanyReports
                  refetch={{ refetchTable, setRefetchTable }}
                  values={{ selectedValues, setSelectedValues }}
                  viewField={viewField}
                  operatorsDisabled={operatorsDisabled}
                  rowSelection={{ rowSelectionModel, setRowSelectionModel }}
                  dynProps={dynProps}
                  autocompleteOptions={autocompleteOptions}
                  customerGroups={customerGroups}
                  supplierGroups={supplierGroups}
                  customerVatCode={customerVatCode}
                  supplierVatCode={supplierVatCode}
                  salesPerson={salesPerson}
                  purchasePerson={purchasePerson}
                  jokerFields={jokerFields}
                />
              )}
            </>
          }
        />
      )}
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />

      <CompanySalesPersonDialog
        onClose={() => setSalesPersonDialogOpen(false)}
        open={salesPersonDialogOpen}
        setRefetchTable={setRefetchTable}
        values={{ selectedValues, setSelectedValues }}
        salesPerson={salesPerson}
      />
    </>
  );
};
